import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    user: JSON.parse(localStorage.getItem('user') || 'null')
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    LOGOUT(state) {
      state.token = ''
      state.user = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    }
  },
  actions: {
    login({ commit }, { token, user }) {
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
    },
    // 验证 token 是否有效
    async verifyToken({ state, commit }) {
      if (!state.token) return false
      try {
        const request = (await import('@/utils/request')).default
        const res = await request.get('/auth/verify')
        if (res.code !== 200) {
          commit('LOGOUT')
          return false
        }
        return true
      } catch (e) {
        commit('LOGOUT')
        return false
      }
    },
    async logout({ commit }) {
      // 调用后端登出接口
      try {
        await import('@/utils/request').then(module => {
          const request = module.default
          return request.post('/admin/logout')
        })
      } catch (e) {
        // 忽略登出接口错误
      }
      commit('LOGOUT')
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    currentUser: state => state.user,
    currentStore: state => state.user?.storeId,
    isAdmin: state => state.user?.role === 99,
    isStoreOwner: state => state.user?.role === 1,
    userRole: state => state.user?.role
  }
})
